import React, { useState } from "react";
import { LineChart as LineChartIcon, ExternalLink, RefreshCw, AlertTriangle } from "lucide-react";

/**
 * WartHive Metrics — embed Grafana dashboard via iframe.
 *
 * Anonymous viewer abilitato lato Grafana → nessun login per gli utenti
 * autenticati alla dashboard WartHive. La dashboard "warthive-fleet" è
 * provisionata via file in /etc/grafana/provisioning/dashboards/.
 *
 * Ritrovi tutta la storia da 90 giorni qui — non più limitata ai 100 punti
 * in memoria del backend WartHive v1.0.
 */
export default function MetricsPage() {
  const [reloadKey, setReloadKey] = useState(0);
  const [iframeError, setIframeError] = useState(false);

  // Kiosk=tv: nasconde sidebar Grafana, mantiene il pannello a tutta larghezza
  // theme=dark: matcha il theme della webapp WartHive
  // refresh=15s: aggiornamento live ogni 15 secondi
  const grafanaUrl = `/grafana/d/warthive-fleet/warthive-fleet-overview?orgId=1&kiosk=tv&theme=dark&refresh=15s&_=${reloadKey}`;

  return (
    <div className="p-4 md:p-6 lg:p-8 min-h-screen flex flex-col" data-testid="metrics-page">
      <div className="flex items-start justify-between mb-5">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#10B981] mb-1.5 flex items-center gap-2">
            <LineChartIcon className="w-3 h-3" />
            // Live Metrics & 90-Day History
          </div>
          <h1 className="font-heading font-black text-3xl md:text-4xl tracking-tight">
            Metrics
          </h1>
          <p className="text-sm text-[#A1A1AA] mt-1">
            Dashboard Grafana — storico fino a 90 giorni, query PromQL,
            efficienza fleet. Aggiornamento live ogni 15s.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => { setIframeError(false); setReloadKey((k) => k + 1); }}
            data-testid="metrics-refresh-btn"
            className="px-3 py-2 text-xs font-mono uppercase tracking-wider text-[#A1A1AA] hover:text-[#10B981] hover:bg-[#10B981]/10 rounded-sm border border-[#27272A] hover:border-[#10B981]/40 transition-colors flex items-center gap-1.5"
          >
            <RefreshCw className="w-3.5 h-3.5" /> Refresh
          </button>
          <a
            href="/grafana/d/warthive-fleet/warthive-fleet-overview?orgId=1&theme=dark"
            target="_blank"
            rel="noreferrer"
            data-testid="metrics-open-grafana"
            className="px-3 py-2 text-xs font-mono uppercase tracking-wider text-[#09090B] bg-[#10B981] hover:bg-[#34D399] rounded-sm flex items-center gap-1.5 font-bold"
          >
            <ExternalLink className="w-3.5 h-3.5" /> Apri Grafana
          </a>
        </div>
      </div>

      {iframeError ? (
        <div className="bento p-6 text-center" data-testid="metrics-error">
          <AlertTriangle className="w-10 h-10 text-[#F59E0B] mx-auto mb-3" />
          <h3 className="font-heading font-bold text-lg mb-1">Grafana non raggiungibile</h3>
          <p className="text-sm text-[#A1A1AA] max-w-md mx-auto mb-4">
            Verifica che il container <code className="font-mono text-[#10B981]">warthive-grafana</code> sia
            attivo e che nginx esponga il reverse proxy <code className="font-mono text-[#10B981]">/grafana/</code>.
            Avvialo con <code className="font-mono text-[#10B981]">docker compose up -d grafana prometheus</code>.
          </p>
          <button
            onClick={() => { setIframeError(false); setReloadKey((k) => k + 1); }}
            className="px-4 py-2 text-xs font-mono uppercase tracking-wider text-[#09090B] bg-[#10B981] rounded-sm font-bold"
          >
            Riprova
          </button>
        </div>
      ) : (
        <div
          className="bento flex-1 p-0 overflow-hidden min-h-[calc(100vh-220px)]"
          data-testid="metrics-iframe-container"
        >
          <iframe
            key={reloadKey}
            src={grafanaUrl}
            className="w-full h-full border-0"
            title="WartHive Grafana"
            data-testid="metrics-grafana-iframe"
            onError={() => setIframeError(true)}
          />
        </div>
      )}
    </div>
  );
}
